module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-12-min.70a55db6.jpg";